var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoYouKnowBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 656,
    viewBox: "0 0 662 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    y: 305,
    width: 558.806,
    height: 351,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 289,
    r: 289,
    fill: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4681 419C83.4681 419 80.5243 546.978 89.3712 628H265.001C265.001 628 235.485 475.176 236.949 419H83.4681Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.654 454.746V494.751H180.582L177.451 447.936L103.654 454.746Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.203 531.46C208.821 531.46 223.102 518.631 223.102 502.805C223.102 486.979 208.821 474.149 191.203 474.149C173.586 474.149 159.305 486.979 159.305 502.805C159.305 518.631 173.586 531.46 191.203 531.46Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.418 482.857L174.055 520.172C174.055 520.172 159.648 506.692 169.491 491.455C179.335 476.217 197.418 482.857 197.418 482.857Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.945 484.925L180.582 523.5C180.582 523.5 197.419 533.824 210.176 516.954C222.932 500.084 203.945 484.925 203.945 484.925Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.581 486.899V494.674L171.002 494.316C171.917 492.426 173.258 490.773 174.92 489.486C176.582 488.199 178.519 487.314 180.581 486.899V486.899Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.115 514.528V523.5L150.521 519.022V514.528H106.115Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.115 535.441V540.759H199.304L106.115 535.441Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.115 552.296V560.412L237.152 556.354V545.75L106.115 552.296Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.361 570.72V579.147L244.332 574.933V566.973L102.361 570.72Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.654 586.33V592.876L244.332 589.611V583.827L103.654 586.33Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.666 597.245V616.603H255.282L249.021 592.876L183.666 597.245Z",
    fill: "#A9CBDA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 209,
    fill: "white",
    transform: "translate(83 419)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoYouKnowBg);
export default __webpack_public_path__ + "static/media/do_you_know_bg.36b2c06fe4ed307ffad8d5d26c5cd6aa.svg";
export { ForwardRef as ReactComponent };